export default __webpack_public_path__ + "static/media/hessahStore2.61bfe650.jpg";